import { PaymentMethodType } from './paymentMethod'

export interface CustomerAccount {
  accountId: string
  accountCode: string
  accountStatus: AccountStatus
  paymentMethodType?: PaymentMethodType
  accountBalance: number
  paymentDay: number
  outstandingAmount: number
  statementFrequency: 'ANNUAL' | 'MONTHLY' | undefined
}

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
}
